export interface IDashLabDetails {

}